export enum PlayerPosition {
  DEFENDER = 'defender',
  FORWARD = 'forward',
  GOALKEEPER = 'goalkeeper',
  MIDFIELDER = 'midfielder',
}
